import { render, staticRenderFns } from "./CityForm.vue?vue&type=template&id=97221f5c"
import script from "./CityForm.vue?vue&type=script&lang=js"
export * from "./CityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports